import { render, staticRenderFns } from "./PriceCheckAI.vue?vue&type=template&id=105be78b&scoped=true"
import script from "./PriceCheckAI.vue?vue&type=script&lang=js"
export * from "./PriceCheckAI.vue?vue&type=script&lang=js"
import style0 from "./PriceCheckAI.vue?vue&type=style&index=0&id=105be78b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105be78b",
  null
  
)

export default component.exports